import * as React from 'react';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { Store } from 'redux';
import { Helmet } from 'react-helmet';

import i18next from '../../config/i18next';
import configureStore from '../../store';
import { __DEBUG__, DEFAULT_LANGUAGE } from '../../config/constants';
import Router from '../Router';

import(/* webpackChunkName: "design-system" */ '../../styles/design-system.scss');

const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL,
});

// The `configureStore` method is written in plain JS and
// therefore it return value has an any type. To prevent
// typescript issues we typecast it here to be `Store`.
const store = configureStore(history) as Store;

const App: React.FC = () => {
  return (
    <>
      <Helmet><html lang={DEFAULT_LANGUAGE} /></Helmet>
      <Provider store={store}>
        <I18nextProvider i18n={i18next}>
          <Router />
        </I18nextProvider>
      </Provider>
    </>
  );
};

export default App;
